import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import axios from "axios";
import config from "../config/config";
import Cookies from "js-cookie";
import axiosInstance from "../AxiosInstance";

const AdminUserContext = createContext();

export const AdminUserProvider = ({ children }) => {
  const [adminUser, setAdminUser] = useState(null);
  const [loggedInAdminUser, setLoggedInAdminUser] = useState(null);

  const fetchAdminUserData = useCallback(async () => {
    try {
      const tokenResponse = await axiosInstance.get(
        `${config.API_BASE_URL}/v1/auth/get-token`
      );
      const token = tokenResponse.data.token;

      if (token) {
        console.log("Token retrieved from API:", token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        const response = await axiosInstance.get(
          `${config.API_BASE_URL}/v1/admin/auth/authenticated-admin-users`
        );
        const user = response.data;
        console.log("Context Logged In User data fetched:", user);
        if (user.userType === "admin") {
          setAdminUser(user);
        }
        return user;
      } else {
        console.error("Token not retrieved from API");
      }
    } catch (error) {
      console.error("Failed to fetch token and user data:", error);
      throw error;
    }
  }, []);

  const fetchLoggedInAdminUser = useCallback(async () => {
    try {
      const sessionId = Cookies.get("sessionId");
      if (!sessionId) {
        console.log("No session ID found. Cannot fetch logged-in user.");
        return [];
      }

      console.log("Session ID found:", sessionId);
      const response = await axiosInstance.get(
        `${config.API_BASE_URL}/v1/admin/auth/authenticated-admin-users`,
        {
          headers: {
            sessionId: sessionId,
          },
        }
      );

      const userArray = response.data;
      if (Array.isArray(userArray) && userArray.length > 0) {
        console.log("Logged In User data (array):", userArray);
        const user = userArray[0];
        setLoggedInAdminUser(user);
        return userArray;
      } else {
        console.log("No logged-in user found.");
        return [];
      }
    } catch (error) {
      console.error("Failed to fetch logged-in user by session ID:", error);
      return [];
    }
  }, []);

  const fetchAdminUserDetailsById = async (userId) => {
    try {
      const response = await axiosInstance.get(
        `${config.API_BASE_URL}/v1/administration/${userId}`
      );
      const user = response.data;
      console.log("Admin User fetched by ID :", user);
      if (user && user.assignedRole) {
        setAdminUser(user);
      }
      console.log("Fetched Admin user details by ID:", user);
    } catch (error) {
      console.error("Failed to fetch user details by ID:", error);
    }
  };

  const clearAdminUserData = () => {
    console.log("clearAdminUserData invoked");
    if (adminUser) {
      console.log("Logging out admin user:", adminUser.email);
      setAdminUser(null);
    }
    Cookies.remove("user");
    document.cookie =
      "jwtToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    axios.defaults.headers.common["Authorization"] = undefined;
  };

  const logout = async () => {
    try {
      await axiosInstance.post(`${config.API_BASE_URL}/v1/auth/logout`, {});
      clearAdminUserData();
      console.log("Admin user logged out successfully");
      window.location.href = "/admin/login";
    } catch (error) {
      console.error("Failed to log out:", error);
    }
  };

  return (
    <AdminUserContext.Provider
      value={{
        adminUser,
        loggedInAdminUser,
        setLoggedInAdminUser,
        fetchLoggedInAdminUser,
        setAdminUser,
        fetchAdminUserDetailsById,
        fetchAdminUserData,
        clearAdminUserData,
        logout,
      }}
    >
      {children}
    </AdminUserContext.Provider>
  );
};

export const useAdminUser = () => useContext(AdminUserContext);
